export const FETCH_ACTIVE_PGAPPS_START = 'FETCH_ACTIVE_PGAPPS_START';
export const FETCH_ACTIVE_PGAPPS_SUCCESS = 'FETCH_ACTIVE_PGAPPS_SUCCESS';
export const FETCH_ACTIVE_PGAPPS_FAILURE = 'FETCH_ACTIVE_PGAPPS_FAILURE';


export const UPDATE_NOTIFICATION_START = 'UPDATE_NOTIFICATION_START';
export const UPDATE_NOTIFICATION_SUCCESS = 'UPDATE_NOTIFICATION_SUCCESS';
export const UPDATE_NOTIFICATION_FAILURE = 'UPDATE_NOTIFICATION_FAILURE';

export const GET_UNREAD_NOTIFICATION_START = 'GET_UNREAD_NOTIFICATION_START';
export const GET_UNREAD_NOTIFICATION_SUCCESS = 'GET_UNREAD_NOTIFICATION_SUCCESS';
export const GET_UNREAD_NOTIFICATION_FAILURE = 'GET_UNREAD_NOTIFICATION_FAILURE';